const families = new Map();
let counter = 0;

function fontFormat(url) {
  const path = url.split("?")[0].toLowerCase();
  if (path.endsWith(".woff2")) return "woff2";
  if (path.endsWith(".woff")) return "woff";
  if (path.endsWith(".ttf")) return "truetype";
  if (path.endsWith(".otf")) return "opentype";
  return null;
}

/**
 * Injects an @font-face for a monogram_font file (once per URL) and returns
 * the generated family name.
 *
 * @param {string|null|undefined} url
 * @returns {string|null}
 */
export function monogramFontFamily(url) {
  if (!url) return null;
  if (families.has(url)) return families.get(url);

  const family = `monogram-font-${++counter}`;
  const format = fontFormat(url);
  const src = format ? `url("${url}") format("${format}")` : `url("${url}")`;

  const style = document.createElement("style");
  style.textContent = `@font-face{font-family:"${family}";src:${src};font-display:swap;}`;
  document.head.appendChild(style);

  families.set(url, family);
  return family;
}

/** A font-family value for a monogram_font file, or undefined. */
export function fontFamilyStyle(url) {
  const family = monogramFontFamily(url);
  return family ? `"${family}", var(--font-primary)` : undefined;
}
